import { Component, Input } from '@angular/core';
import { History } from 'src/app/shared/models/iCourrier/history';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { MeRightMail, UserContact } from 'src/app/shared/models';
import { TranslateService } from '@devinforius/i-essentials';
import { UsersService } from 'src/app/shared/services/users.service';
import { UserDto } from 'src/app/shared/interfaces/users';
import { catchError, map } from 'rxjs/operators';
import { AccessHistory } from 'src/app/shared/models/iCourrier/access-history';
import { MailsService } from 'src/app/shared/services/mails.service';
import { MailsRightsService } from 'src/app/shared/services/mails-rights.service';
import { Cols } from 'src/app/shared/models/cols';
import { ITabs } from '@devinforius/i-navigation';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-courrier-fiche-history',
  templateUrl: './courrier-fiche-history.component.html',
  styleUrls: ['./courrier-fiche-history.component.scss'],
})
export class CourrierFicheHistoryComponent {
  public orderMglTimeline = [
    { label: 'courrierHistory.mostRecentFirst', value: 'ASC' },
    { label: 'courrierHistory.olderFirst', value: 'DESC' },
  ];

  @Input() public set mailId(value) {
    this.courrierID = value;
    this.loadingDisplay = true;
    if (value) {
      this.tabsArray = [];
      this.histories = [];
      this.setDatas();
    }
  }
  public histories: History[] = [];

  // TimeLine
  public size = 10;
  public side = '';
  public expandEnabled = false;
  public contentAnimation = true;
  public dotAnimation = true;
  public color = false;
  public tabsArray: ITabs[] = [];
  public currentTab: string;
  public columns: Cols[] = [
    {
      field: 'name',
      header: 'name',
      sortable: true,
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return 'Pas de nom';
        }
      },
    },
    {
      field: 'typeLabel',
      header: 'type',
      sortable: true,
      format: (_value: string, item): string => {
        if (item.type) {
          return this.translater.translate(item.type);
        } else {
          return '/';
        }
      },
    },
    {
      field: 'description',
      header: 'description',
      sortable: true,
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'modifieLe',
      header: 'courrierHistory.modifiedOnThe',
      type: 'string',
      format: (_item: string, value): string => {
        if (value.modifieLe) {
          return moment(value.modifieLe).format('DD/MM/YYYY à HH:mm');
        } else {
          return '/';
        }
      },
      sort: (a: string, b: string, order: number) => {
        const val1 = moment(a, 'DD/MM/YYYY').isValid() ? moment(a, 'DD/MM/YYYY').unix() : null;
        const val2 = moment(b, 'DD/MM/YYYY').isValid() ? moment(b, 'DD/MM/YYYY').unix() : null;
        if (val1 === null) return 1;
        else if (val2 === null) return -1;
        else return val1 < val2 ? 1 * order : -1 * order;
      },
      sortable: true,
    },
  ];
  public order = 'ASC';
  public rights: AccessHistory[] = [];
  public columnsRight: Cols[] = [
    {
      field: 'name',
      header: 'name',
      format: (value: string): string => {
        return value ? value : '/';
      },
    },
    {
      field: 'premiereVisite',
      header: 'courrierHistory.firstVisit',
      format: (_item, value) => {
        if (value.premiereVisite) {
          return moment(value.premiereVisite).format('DD/MM/YYYY');
        } else {
          return '/';
        }
      },
      sort: (a, b, order) => {
        const val1 = moment(a, 'DD/MM/YYYY').isValid() ? moment(a, 'DD/MM/YYYY').unix() : null;
        const val2 = moment(b, 'DD/MM/YYYY').isValid() ? moment(b, 'DD/MM/YYYY').unix() : null;
        if (val1 === null) return 1;
        else if (val2 === null) return -1;
        else return val1 < val2 ? 1 * order : -1 * order;
      },
      sortable: true,
    },
    {
      field: 'derniereVisite',
      header: 'courrierHistory.lastVisit',
      format: (_item, value) => {
        if (value.derniereVisite) {
          return moment(value.derniereVisite).format('DD/MM/YYYY');
        } else {
          return '/';
        }
      },
      sort: (a, b, order) => {
        const val1 = moment(a, 'DD/MM/YYYY').isValid() ? moment(a, 'DD/MM/YYYY').unix() : null;
        const val2 = moment(b, 'DD/MM/YYYY').isValid() ? moment(b, 'DD/MM/YYYY').unix() : null;
        if (val1 === null) return 1;
        else if (val2 === null) return -1;
        else return val1 < val2 ? 1 * order : -1 * order;
      },
      sortable: true,
    },
    {
      field: 'droitActif',
      header: 'courrierHistory.activeRight',
      format: (_value, item) => {
        if (item.droitActif) {
          return this.showBoolean(item.droitActif);
        }
      },
    },
  ];
  public loadingDisplay: boolean = true;
  public courrierID: number;
  public users: UserContact[];

  constructor(
    public spinner: NgxSpinnerService,
    private translater: TranslateService,
    private usersService: UsersService,
    private mailsService: MailsService,
    private mailsRightsService: MailsRightsService,
    private toastr: ToastrService
  ) {}

  private setDatas(): void {
    this.setTranslations();
    this.tabsArray = [];
    this.users = [];

    if (!this.courrierID) {
      this.toastr.error("Le courrier n'existe pas");
      return;
    }

    forkJoin({
      rightsMailByID: this.mailsRightsService.getRightsMailByID(this.courrierID).pipe(
        catchError(() => {
          this.spinner.hide();
          return of(null);
        })
      ),
      users: this.usersService.fetchUsersFromiAdmin().pipe(map((res: UserDto[]) => res.map((user: UserDto) => new UserContact(user)))),
    }).subscribe((res) => {
      this.setTabsWithRights(res.rightsMailByID);
      this.users = res.users;
      forkJoin({
        historyRights: res.rightsMailByID.viewHistory ? this.getMailHistory() : of(null),
        viewRights: res.rightsMailByID.viewDroits ? this.getAccessHistory() : of(null),
      }).subscribe(() => {
        this.initTabs();
        this.loadingDisplay = false;
      });
    });
  }

  private setTranslations(): void {
    this.orderMglTimeline.map((tab) => {
      tab.label = this.translater.translate(tab.label);
    });

    this.columnsRight.map((column) => {
      column.header = this.translater.translate(column.header);
    });
    this.columns.map((column) => {
      column.header = this.translater.translate(column.header);
    });
  }

  private setTabsWithRights(rights: MeRightMail): void {
    if (rights.viewHistory) {
      this.tabsArray = [
        { header: this.translater.translate('courrierHistory.vue.timeline'), id: 'timeline' },
        { header: this.translater.translate('courrierHistory.vue.table'), id: 'table' },
      ];
    }
    if (rights.viewDroits && this.tabsArray.map((x) => x.id).indexOf('right') === -1) {
      this.tabsArray.push({ header: this.translater.translate('courrierHistory.vue.rights'), id: 'right' });
    }
  }

  public getMailHistory(): Promise<boolean> {
    return new Promise((resolve) => {
      this.mailsService.getHistory(this.courrierID).subscribe({
        next: (historyFromQuery) => {
          this.histories = [];

          historyFromQuery.forEach((history) => {
            const historyWithNameInfo = new History(history, this.users);
            this.histories.push(historyWithNameInfo);
          });
          resolve(true);
        },
        error: (error) => {
          console.error(error);
        },
      });
    });
  }

  getAccessHistory(): Promise<boolean> {
    return new Promise((resolve) => {
      this.mailsService.getAccessHistory(this.courrierID).subscribe({
        next: (accessHistoryFromQuery) => {
          this.rights = [];

          accessHistoryFromQuery.forEach((accessHistory) => {
            const accessHistoryWithName = new AccessHistory(accessHistory);
            const userFound = this.users.find((x) => x.userId === accessHistory.userId);
            if (userFound) {
              accessHistoryWithName.setName(userFound);
            }
            this.rights.push(accessHistoryWithName);
          });

          resolve(true);
        },
      });
    });
  }

  initTabs(): void {
    const activeTabs = this.tabsArray[0];
    activeTabs.active = true;
    this.currentTab = this.tabsArray[0].id;
  }

  onHeaderClick(event): void {
    event.stopPropagation();
  }

  onDotClick(event): void {
    event.stopPropagation();
  }

  receive_tabs(event): void {
    this.currentTab = event;
  }

  changeOrder(ordre): void {
    if (ordre === 'ASC') {
      this.histories = this.histories.sort((a, b) => (moment(a['modifieLe'], 'DD-MM-YYYY').isBefore(moment(b['modifieLe'], 'DD-MM-YYYY')) ? -1 : 1));
    } else {
      this.histories = this.histories.sort((a, b) => (moment(a['modifieLe'], 'DD-MM-YYYY').isBefore(moment(b['modifieLe'], 'DD-MM-YYYY')) ? 1 : -1));
    }
  }

  private showBoolean(value): string {
    if (value) {
      return `✅`;
    } else if (value === -1) {
      return `⌛`;
    } else {
      return `❌`;
    }
  }
}
